import { SendMessageResponse as RocketLLMSendMessageResponse } from '@rocketlane/rocket-llm';
import { HttpClient } from 'api/http-client';
import { API_HOST } from 'config/environment';

class ChatAPIClient extends HttpClient {
  constructor() {
    super();
    const apiInstance = this.api();

    apiInstance.defaults.baseURL = `${API_HOST}/api/v1`;
  }

  // Send message with sections (for chat-sidebar)
  public sendMessageWithSections = async <T = any>(payload: {
    message: {
      sections: T[];
      message_metadata?: Record<string, unknown>;
    };
    conversation_id: string;
    conversation_metadata?: Record<string, unknown>;
    edit_mode?: null;
    conversation_type?: string;
    target_message_id?: number;
  }): Promise<RocketLLMSendMessageResponse> => {
    return this.post<RocketLLMSendMessageResponse, typeof payload>(
      '/chat',
      payload,
    );
  };
}

export const ChatAPI = new ChatAPIClient();
